"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
const TribeSkeleton = () => {
    return (react_1.default.createElement("div", { className: "py-[16px] px-[16px] bg-n-000 shadow-raised rounded-[4px] cursor-pointer relative group flex flex-col h-[308px]" },
        react_1.default.createElement("div", { className: "inline-flex gap-[12px]  mb-[16px]" },
            react_1.default.createElement(Shimmer_1.default, { width: 56, height: 56 }),
            react_1.default.createElement("div", { className: "flex flex-grow flex-col" },
                react_1.default.createElement(Shimmer_1.default, { width: "57%", height: 24, customClass: "mb-[8px]" }),
                react_1.default.createElement(Shimmer_1.default, { width: "100%", height: 20 }))),
        react_1.default.createElement("div", { className: "inline-flex gap-[10px] mb-[16px]" },
            react_1.default.createElement(Shimmer_1.default, { width: 24, height: 24, circle: true }),
            react_1.default.createElement("div", { className: "flex flex-grow" },
                react_1.default.createElement(Shimmer_1.default, { width: "100%", height: 24 })),
            react_1.default.createElement("div", { className: "inline-flex gap-[4px]" },
                react_1.default.createElement(Shimmer_1.default, { width: 24, height: 24, circle: true }),
                react_1.default.createElement(Shimmer_1.default, { width: 24, height: 24, circle: true }),
                react_1.default.createElement(Shimmer_1.default, { width: 24, height: 24, circle: true }))),
        react_1.default.createElement(Shimmer_1.default, { width: 76, customClass: "mb-[8px]" }),
        react_1.default.createElement(Shimmer_1.default, { width: "100%", height: 136 })));
};
exports.default = TribeSkeleton;
